import { type GoogleMapsOptions } from "@client/content/controls/GoogleMaps/component";
import {
  combinedSettingsSelector,
  getSettingValueSelector,
  type SettingsPropsParametricSelector,
  TargetSelector
} from "@client/selectors";
import { createSelector } from "reselect";

export const makeGoogleKeySelector = (): SettingsPropsParametricSelector => {
  const googleKeySelector = getSettingValueSelector(TargetSelector.Entity, "googleKey");

  return createSelector([googleKeySelector], (googleKey) =>
    !googleKey || googleKey === "insert_your_google_key_here" ? "" : googleKey
  );
};

export const makeOptionsSelector = () =>
  combinedSettingsSelector<GoogleMapsOptions>(TargetSelector.Entity, [
    { name: "mapAddress", prop: "address" },
    { name: "mapAddress2", prop: "address2" },
    { name: "mapAddress3", prop: "address3" },
    { name: "mapType", prop: "type" },
    { name: "mapZoom", converter: (v) => parseFloat(v), prop: "zoom" }
  ]);
